import React from 'react';
import './Contact.css';

const Contact = () => {
  const handleEmailClick = () => {
    window.open('mailto:contact@techaimz.com');
  };

  return (
    <section className="contact-section">
      <div className="contact-info">
        <div className="contact-item" onClick={handleEmailClick} title="Click to send email">
          <span className="contact-label">EMAIL:</span>
          <span className="contact-value">contact@techaimz.com</span>
        </div>
      </div>
    </section>
  );
};

export default Contact;